var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C10.7816 22 9.69507 21.4145 8.98798 20.5H15.012C14.305 21.4145 13.2184 22 12 22Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0354 3C11.0354 2.44772 11.4673 2 12 2C12.5327 2 12.9646 2.44772 12.9646 3V3.08296C15.7017 3.55904 17.7874 6.027 17.7874 9V15.5858C17.7874 15.851 17.889 16.1054 18.0699 16.2929L19.8578 18.1464C20.1616 18.4614 19.9464 19 19.5167 19H4.48325C4.05358 19 3.8384 18.4614 4.14222 18.1464L5.9301 16.2929C6.11099 16.1054 6.21261 15.851 6.21261 15.5858V9C6.21261 6.027 8.29828 3.55904 11.0354 3.08296V3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.43258375ab88b24ee1171da114d16410.svg";
export { ForwardRef as ReactComponent };